import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import { getStudents } from '../api';
import { StudentsRemovalRequestStudentsResponse } from '../types/students';

export const ITEMS_PER_PAGE_DEFAULT = 10;

export interface StudentsRemovalRequestStudentsQuery {
  page: number;
  studentNameOrId?: string;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  StudentsRemovalRequestStudentsQuery,
  StudentsRemovalRequestStudentsResponse,
  AxiosResultDefaultError
>();

export const useStudentsRemovalRequestStudentstList = useFetch;

export function StudentsRemovalRequestStudentsListConsumer({
  children,
}: {
  children: (args: {
    data?: StudentsRemovalRequestStudentsResponse;
    loading: boolean;
    refresh: () => Promise<void>;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              insideCard
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data, loading, refresh });
      }}
    </FetchConsumer>
  );
}

export function StudentsRemovalRequestStudentsListLoader({
  children,
}: {
  children: ReactElement | ReactElement[];
}) {
  const request = useCallback(
    async (query: StudentsRemovalRequestStudentsQuery) => {
      return getStudents({
        ...query,
        page: query.page - 1,
      });
    },
    [],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1 }}
      children={children}
    />
  );
}
